import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;

export const TeamContainer = styled.div`
    img {
        height: 36px;
        width: 54px;
    }
`;

export const HeaderTextContainer = styled.div`
    flex: 1;
    text-align: center;
`;

export const HeaderText = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
`;

export const SubHeaderText = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
`;
